import axios from "axios";
import { SERVER_URL } from "Constants";
import useAsync from "Hooks/useAsync";
import { ComboboxOption } from "Views/Components/Combobox/Combobox";
import ComboboxSetter from "Views/Components/Combobox/ComboboxSetter";
import { GenerateCreditReportStage } from "../../GenerateCreditReport";

export type CreditProvider = {
	id: string;
	name: string;
	description: string;
	type: string;
	isActive: boolean;
	organisationId: string;
}

async function getAvailableCreditProviders(organisationId: string) {
	const params = !!organisationId ? { organisationId } : {};
	const response = await axios.get<CreditProvider[]>(`${SERVER_URL}/api/entity/ProviderEntity/list`, {
		params
	});
	return response.data;
}

type Props = {
	isCustomerGenerate: boolean;
	countryCode: string;
	provider?: CreditProvider;
	updateProvider: (data: CreditProvider) => void;
	organisationId: string;
	changeStage: (stage: GenerateCreditReportStage) => void;
}

const getAvailableCreditProviderOptions = (data?: CreditProvider[]): ComboboxOption<CreditProvider>[] => {
	if (!data) {
		return [];
	}
	const options = data.filter(item => item.isActive).map((item => ({
		value: item,
		display: item.name,
	})));

	options.sort((a, b) => a.display.localeCompare(b.display));

	return options;
}


export const CreditProviderSection: React.FunctionComponent<Props> = ({
	isCustomerGenerate,
	countryCode,
	provider,
	updateProvider,
	organisationId,
	changeStage
}) => {
	const response = useAsync(async () => {
		return await getAvailableCreditProviders(organisationId);
	}, []);

	const availableCreditProviderOptions = getAvailableCreditProviderOptions(response.data);
	

	const handleProviderChange = (selectedProvdier: CreditProvider) => {
		const isCountryCodeInternational = countryCode !== "AU" && countryCode !== "NZ";
		const isProviderCoface = selectedProvdier.name.toLowerCase() === "coface";
		const isInterimFormPath = isCountryCodeInternational || isProviderCoface;
		updateProvider(selectedProvdier);
		changeStage(isInterimFormPath ? "interimForm" : "requestEntity");
	}

	if (!response.data) return <></>
	return (
		<ComboboxSetter
			value={provider}
			setValue={handleProviderChange}
			options={availableCreditProviderOptions}
			getOptionValue={data => data?.id}
			label="Select Credit Bureau"
			placeholder="Select Credit Bureau"
		/>
	)
}